import React, { useState } from 'react'
import Modall from './Modall'
import line from './asset/line.png'
import Footer from './Footer'
import Fav from './asset/fav.png' // Correct import for the Fav image

const Page1 = () => {
    const [show, setShow] = useState(false)

    const clkHnd = () => {
        setShow(true)
    }

    return (
        <div className='bg-black text-white pt-14 min-h-screen Page1 animate__animated animate__fadeIn'>
            {/* Fav Image Section */}
            <div className="flex justify-center mb-0"> {/* Increased margin-bottom here */}
                <img src={Fav} alt="Fav" className="max-w-xs sm:max-w-sm md:max-w-md" />
            </div>

            {/* Welcome Text Section */}
            <p className=" text-center py-8 text-2xl sm:text-3xl md:text-4xl font-semibold text-gold1 text-4xl sm:text-5xl md:text-6xl lg:text-5xl font-semibold text-center py-1 font-sans animate__animated animate__fadeIn"
                style={{ color: '#DBB76A' }}>
                Welcome Traders And Investors
            </p>


            {/* Line Separator with animation */}
            <div className="mx-auto w-1/1 sm:w-1/4 md:w-1/6" style={{ marginTop: '-45px' }}>
                <img className='mx-auto block animate__animated animate__fadeIn' src={line} alt="Line" />
            </div>

            {/* Marathi Text Section */}
            <div className="mt-4">
                <p className='text-center text-xl sm:text-2xl md:text-3xl font-semibold mb-4 mx-2 sm:mx-8 md:mx-14 font-sans animate__animated animate__fadeIn animate__delay-1s sm:leading-relaxed' style={{ marginTop: '-20px' }}>
                    शेअर मार्केटच्या अथांग समुद्रातून आपली Wealth Generation कशी होईल हे शिकून तुम्ही देखील तुमचे
                </p>

                <p className='text-center text-xl sm:text-2xl md:text-3xl font-semibold mb-8 mx-2 sm:mx-8 md:mx-16 font-sans animate__animated animate__fadeIn animate__delay-2s sm:leading-relaxed'>
                    आर्थिक भविष्य सुरक्षित करा.
                </p>
                <p className='text-center text-xl sm:text-2xl md:text-3xl font-semibold mb-4 mx-2 sm:mx-8 md:mx-16 font-sans animate__animated animate__fadeIn animate__delay-3s sm:leading-relaxed'>
                    आपल्या Portfolio चे योग्य Planning करून मार्केटमधून आपली Wealth Create करण्यासाठी
                </p>
                <p className='text-center text-xl sm:text-2xl md:text-3xl font-semibold mb-12 mx-2 sm:mx-8 md:mx-16 font-sans animate__animated animate__fadeIn animate__delay-4s sm:leading-relaxed'>
                    त्वरित आपला One-to-One call Book करा.
                </p>
            </div>

            {/* Modal */}
            <Modall show={show} setShow={setShow}></Modall>

            {/* Footer */}
            <div className='bg-black h-32'></div>
            <Footer></Footer>
        </div>
    )
}

export default Page1
